import { type CTNUploadProps } from '@ctn/ui/types/ctn-upload';
import { type Icon } from '@ctn/ui/types/generic';

import { type IDocumento } from '@/interfaces/model/don.interface';
import { type TipoDocumento } from '@/interfaces/model/maestros.interface';

import { getLookup } from './dropdown';

const commonUpload: Pick<CTNUploadProps, 'button' | 'validExtensions'> = {
	button: { size: 'size-40' },
	validExtensions: ['pdf'],
};

/**
 * Devuelve el icono de un documento realizando una búsqueda las extensionesPermitidas.
 */
export const getIconDocumento = (documento?: IDocumento): Icon => {
	const icon = documento?.mimeType?.icono;
	return icon ?? 'fileDuotone';
};

export const getConfigUpload = ({
	tipoDocumentoMaestros,
	idTipoDocumento,
	value,
}: {
	tipoDocumentoMaestros: TipoDocumento[];
	idTipoDocumento?: number;
	value?: IDocumento;
}): Partial<Pick<CTNUploadProps, 'fileLoaded' | 'validExtensions'>> => {
	if (!idTipoDocumento) return {};

	const tipoDocumentoMaestro = getLookup(idTipoDocumento, tipoDocumentoMaestros);
	if (!tipoDocumentoMaestro) return {};

	const validExtensions = tipoDocumentoMaestro.extensionesPermitidas?.map(({ extension }) => extension);
	if (!value)
		return {
			validExtensions,
		};

	const { nombre } = value;
	const icon = getIconDocumento(value);

	return {
		fileLoaded: { name: nombre, icon },
		validExtensions,
	};
};

export { commonUpload };
